import React, { useState } from 'react';

export default function PatientStoriesSection() {
  const [activeCategory, setActiveCategory] = useState('respiratory');

  const categories = [
    { id: 'respiratory', name: 'Respiratory Conditions', icon: 'ri-lungs-line' },
    { id: 'chronic', name: 'Chronic Diseases', icon: 'ri-heart-pulse-line' },
    { id: 'skin', name: 'Skin & Healing', icon: 'ri-hand-heart-line' },
    { id: 'wellness', name: 'General Wellness', icon: 'ri-leaf-line' }
  ];

  const testimonials = {
    respiratory: [
      {
        name: 'Rajesh Kumar',
        age: 65,
        condition: 'COPD',
        location: 'Delhi',
        story: 'After 10 years of struggling with COPD, the oxygen capsules have given me my life back. I can walk without breathlessness and sleep peacefully through the night.',
        rating: 5,
        improvement: '70% better breathing',
        duration: '6 months',
        avatar: 'https://public.readdy.ai/ai/img_res/8294486941cd7fb4cb752fb7e5b13b78.jpg'
      },
      {
        name: 'Meera Patel',
        age: 42,
        condition: 'Sleep Apnea',
        location: 'Mumbai',
        story: 'Sleep apnea was ruining my marriage and career. With DLF oxygen therapy, my sleep quality improved dramatically. My husband says I no longer snore!',
        rating: 5,
        improvement: '80% better sleep',
        duration: '4 months',
        avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Indian%20woman%20sleeping%20peacefully%2C%20well-rested%20appearance%2C%20sleep%20apnea%20recovery%2C%20healthy%20glow%2C%20medical%20success%20portrait&width=100&height=100&seq=meera-avatar&orientation=squarish'
      },
      {
        name: 'Dr. Amit Sharma',
        age: 38,
        condition: 'Asthma',
        location: 'Bangalore',
        story: 'As a doctor with severe asthma, I was skeptical. But the oxygen capsules reduced my inhaler dependency by 60%. Now I recommend them to my patients.',
        rating: 5,
        improvement: '60% less medication',
        duration: '8 months',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Indian%20male%20doctor%20smiling%20confidently%2C%20asthma%20recovery%20success%2C%20medical%20professional%20portrait%2C%20white%20coat%2C%20healthy%20breathing&width=100&height=100&seq=amit-avatar&orientation=squarish'
      }
    ],
    chronic: [
      {
        name: 'Priya Joshi',
        age: 29,
        condition: 'PCOD',
        location: 'Pune',
        story: 'PCOD symptoms were controlling my life. The oxygen therapy helped regulate my hormones naturally. My periods are regular and acne has cleared up significantly.',
        rating: 5,
        improvement: 'Hormonal balance restored',
        duration: '5 months',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Indian%20woman%20with%20clear%20glowing%20skin%2C%20PCOD%20recovery%2C%20healthy%20appearance%2C%20confident%20smile%2C%20hormonal%20balance%20success%20story&width=100&height=100&seq=priya-avatar&orientation=squarish'
      },
      {
        name: 'Vikram Singh',
        age: 56,
        condition: 'Cancer Recovery',
        location: 'Jaipur',
        story: 'During my cancer treatment, oxygen capsules helped combat fatigue and boosted my energy levels. My oncologist was amazed at my faster recovery.',
        rating: 5,
        improvement: 'Faster recovery',
        duration: '12 months',
        avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Indian%20man%20with%20strong%20determined%20expression%2C%20cancer%20survivor%2C%20healthy%20recovery%2C%20medical%20success%20story%2C%20hope%20and%20strength&width=100&height=100&seq=vikram-avatar&orientation=squarish'
      },
      {
        name: 'Sunita Devi',
        age: 48,
        condition: 'ILD (Interstitial Lung Disease)',
        location: 'Lucknow',
        story: 'ILD made every breath a struggle. The oxygen support has improved my lung function tests and I can now do household work without gasping for air.',
        rating: 5,
        improvement: 'Improved lung function',
        duration: '10 months',
        avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Indian%20housewife%20smiling%20warmly%2C%20lung%20disease%20recovery%2C%20breathing%20easily%2C%20domestic%20setting%2C%20medical%20success%20story&width=100&height=100&seq=sunita-avatar&orientation=squarish'
      }
    ],
    skin: [
      {
        name: 'Arjun Mehta',
        age: 34,
        condition: 'Psoriasis',
        location: 'Chennai',
        story: 'Psoriasis patches covered 40% of my body. The oxygen sprays and capsules together cleared 80% of my skin. I can wear short sleeves again!',
        rating: 5,
        improvement: '80% skin clearance',
        duration: '7 months',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Indian%20man%20with%20clear%20healthy%20skin%2C%20psoriasis%20recovery%2C%20confident%20expression%2C%20skin%20healing%20success%20story%2C%20medical%20breakthrough&width=100&height=100&seq=arjun-avatar&orientation=squarish'
      },
      {
        name: 'Kavya Reddy',
        age: 31,
        condition: 'Burn Recovery',
        location: 'Hyderabad',
        story: 'After a kitchen accident, the oxygen sprays accelerated my burn healing remarkably. Doctors said it healed 3 times faster than expected.',
        rating: 5,
        improvement: '3x faster healing',
        duration: '3 months',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Indian%20woman%20with%20healed%20skin%2C%20burn%20recovery%20success%2C%20grateful%20expression%2C%20medical%20healing%20miracle%2C%20skin%20regeneration%20success&width=100&height=100&seq=kavya-avatar&orientation=squarish'
      },
      {
        name: 'Rahul Gupta',
        age: 45,
        condition: 'Eczema',
        location: 'Kolkata',
        story: 'Chronic eczema made my hands crack and bleed. The oxygen skincare routine healed my skin completely. No more steroid creams needed!',
        rating: 5,
        improvement: 'Complete healing',
        duration: '6 months',
        avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Indian%20man%20showing%20healthy%20hands%2C%20eczema%20recovery%2C%20healed%20skin%2C%20medical%20success%20story%2C%20skin%20health%20restoration&width=100&height=100&seq=rahul-avatar&orientation=squarish'
      }
    ],
    wellness: [
      {
        name: 'Rekha Agarwal',
        age: 52,
        condition: 'Aging & Wrinkles',
        location: 'Ahmedabad',
        story: 'The oxygen anti-aging treatment turned back the clock by 10 years. My fine lines disappeared and skin feels firmer. People ask what my secret is!',
        rating: 5,
        improvement: '10 years younger look',
        duration: '9 months',
        avatar: 'https://readdy.ai/api/search-image?query=Elegant%20middle-aged%20Indian%20woman%20with%20youthful%20glowing%20skin%2C%20anti-aging%20success%2C%20fine%20lines%20reduced%2C%20confident%20mature%20beauty%2C%20skincare%20success&width=100&height=100&seq=rekha-avatar&orientation=squarish'
      },
      {
        name: 'Suresh Nair',
        age: 39,
        condition: 'Fatigue & Low Energy',
        location: 'Kochi',
        story: 'Constant fatigue was affecting my work performance. Oxygen therapy boosted my energy levels dramatically. I feel 20 years younger!',
        rating: 5,
        improvement: 'Energy levels restored',
        duration: '4 months',
        avatar: 'https://readdy.ai/api/search-image?query=Energetic%20middle-aged%20Indian%20man%2C%20vibrant%20and%20active%2C%20fatigue%20recovery%2C%20high%20energy%20levels%2C%20workplace%20success%2C%20medical%20energy%20boost&width=100&height=100&seq=suresh-avatar&orientation=squarish'
      },
      {
        name: 'Anita Kulkarni',
        age: 36,
        condition: 'General Wellness',
        location: 'Nashik',
        story: 'Started oxygen therapy for general health. Now I have better immunity, clearer thinking, and haven not fallen sick in 8 months!',
        rating: 5,
        improvement: 'Enhanced immunity',
        duration: '8 months',
        avatar: 'https://readdy.ai/api/search-image?query=Healthy%20young%20Indian%20woman%20with%20radiant%20glow%2C%20perfect%20health%2C%20immunity%20boost%20success%2C%20wellness%20transformation%2C%20medical%20prevention%20success&width=100&height=100&seq=anita-avatar&orientation=squarish'
      }
    ]
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Patient Success Stories
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Real experiences from patients who found relief and healing through our oxygen solutions.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 flex items-center space-x-2 ${
                activeCategory === category.id
                  ? 'bg-[#12B6B6] text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className={`${category.icon} text-lg`}></i>
              <span>{category.name}</span>
            </button>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials[activeCategory].map((testimonial, index) => (
            <div key={index} className="bg-[#FAFAFA] rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              {/* Patient Info */}
              <div className="flex items-center space-x-4 mb-6">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-[#111111] text-lg">{testimonial.name}</div>
                  <div className="text-sm text-[#12B6B6] font-medium">{testimonial.condition}</div>
                  <div className="text-xs text-gray-500">{testimonial.location} • Age {testimonial.age}</div>
                </div>
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
                <span className="text-sm text-gray-600 ml-2">({testimonial.rating}/5)</span>
              </div>

              {/* Story */}
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.story}"
              </p>

              {/* Results */}
              <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
                <div>
                  <div className="text-xs text-gray-500 uppercase tracking-wide">Improvement</div>
                  <div className="text-sm font-semibold text-[#12B6B6]">{testimonial.improvement}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 uppercase tracking-wide">Duration</div>
                  <div className="text-sm font-semibold text-[#111111]">{testimonial.duration}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Medical Disclaimer */}
        <div className="mt-16 bg-blue-50 rounded-2xl p-8 text-center">
          <i className="ri-information-line text-3xl text-blue-600 mb-4 block"></i>
          <h3 className="text-lg font-semibold text-blue-900 mb-2">Medical Disclaimer</h3>
          <p className="text-sm text-blue-800 max-w-4xl mx-auto leading-relaxed">
            These testimonials represent individual experiences and results may vary. Our oxygen solutions are complementary 
            to conventional medical treatment and should not replace professional medical advice. Always consult your healthcare 
            provider before starting any new therapy.
          </p>
        </div>
      </div>
    </section>
  );
}